import { render, staticRenderFns } from "./zerocertificate.vue?vue&type=template&id=5c093cb3&scoped=true&"
import script from "./zerocertificate.vue?vue&type=script&lang=js&"
export * from "./zerocertificate.vue?vue&type=script&lang=js&"
import style0 from "./zerocertificate.vue?vue&type=style&index=0&id=5c093cb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c093cb3",
  null
  
)

export default component.exports